export default "__VITE_ASSET__5239d0c2__"